<template>
  <v-dialog :value="showModalInteraction" max-width="700" persistent>
    <v-card class="text-center">
      <v-card-title class="align-center font-weight-bold px-5">
        Thành tích xếp hạng tương tác - {{ childSelected.full_name }} - {{ getMonthText }}
        <v-icon aria-label="Close" @click="closeModal">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pa-4">
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary"
          style="width: 100%"
        ></v-progress-circular>
        <div class="text-left font-size-14 mb-2 pl-2" v-for="interaction in dataInteraction" :key="interaction.id">
          <v-icon class="mr-3" small color="green">mdi-rhombus</v-icon>
          <span class="blue--text">Thông báo > </span>
          <span>{{ interaction }}</span>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style lang="css" scoped>
.font-size-14 {
  font-size: 14px !important;
}
</style>

<script>
import moment from 'moment';
import StudentCareServices from '../../../../services/StudentCareServices';

export default {
  props: {
    subjectId: {
      type: Number,
      default: () => null,
    },
    filterForm: {
      default: () => ({}),
    },
    filter: {
      default: () => ({}),
    },
    childSelected: {
      default: () => ({}),
    },
    showModalInteraction: {
      default: false,
    },
  },
  data() {
    return {
      dataInteraction: [],
      loading: false,
    };
  },
  created() {
    this.viewDetailInteraction();
  },
  methods: {
    closeModal() {
      Bus.$emit('show-modal-interaction', false);
    },
    async viewDetailInteraction() {
      this.loading = true;
      const params = {
        userId: this.filterForm.lmsCoreUserID,
        startTime: moment(this.filter.dateTime[0]).format('YYYY-MM-DD 00:00:00'),
        endTime: moment(this.filter.dateTime[1]).format('YYYY-MM-DD 23:59:59'),
        subjectId: this.subjectId,
      };
      const res = await StudentCareServices.getDetailInteraction(params);
      if (res?.success && res?.data) {
        this.dataInteraction = res?.data;
        this.loading = false;
      }
    },
  },
  computed: {
    getMonthText() {
      return `Tháng ${moment(this.filter.dateMonth).format('MM/YYYY')}`;
    },
  },
};
</script>
